import * as d3 from 'd3';
import * as _ from 'lodash';

export function getOrdinalScale(
    filteredData: (Date | string)[],
    domain: [Date, Date],
    range?: [number, number],
    padding: number = 0.5
) {
    let dates = [];
    if (filteredData && filteredData.length > 0) {
        dates = getDates(filteredData, domain);
    }
    let ordinalScale;
    if (range) {
        ordinalScale = d3.scale.ordinal<any>()
            .domain(dates)
            .rangeBands(range, padding);
    }
    return ordinalScale;
}

function getDates(filteredData: (string | Date)[], domain: [Date, Date]) {
    // Feels weird, left as is for compatibility as type inference seems stupid
    let dates: any[] = _.sortBy(filteredData.map(d => Date.parse(d as string)), d => d);
    let min: number = null;
    for (let i = 1; i < dates.length; i++) {
        const diff = dates[i] - dates[i - 1];
        if (diff > 0 && (!min || diff < min)) {
            min = diff;
        }
    }
    if (min) {
        const beginDate = domain[0];
        const endDate = domain[1].getTime();
        let currentDate = beginDate.getTime();
        while (currentDate <= endDate) {
            const next = currentDate + min;
            dates.push(new Date(next));
            currentDate = next;
        }
    } else {
        dates = filteredData.map(d => d);
    }
    return dates;
}
